export const fetchHardwareModels = defineQuery(() => {
	const { ...query } = useQuery({
		key: () => ["deviceHardwareModels"],
		query: () =>
			getDevicesHardwareModels()
				.then((res) => (res.data as DeviceHardwareModel[]) ?? ([] as DeviceHardwareModel[]))
				.catch(() => {
					return [] as DeviceHardwareModel[]
				})
	})

	return { ...query }
})
